import React, { useEffect, useState } from "react";
import api from "./Api";
import "./HomePage.css";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { FaEye, FaPenAlt, FaReadme, FaRegCalendarAlt, FaThumbsUp } from "react-icons/fa";
import Cookies from "js-cookie";

const HomePage = () => {
  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("Latest");
  const [language, setLanguage] = useState("en");
  const [totalPages, setTotalPages] = useState(0);
  const [isEmptyResponse, setIsEmptyResponse] = useState(false);
  const [allCategories, setAllCategories]= useState([]);
  const [subCategories, setSubCategories]=useState([]);
  const [selectedSubCategory, setSelectedSubCategory]=useState("");

  useEffect(() => {
    fetchCategories('en');
    fetchArticles();
  }, []); 

  const fetchCategories= async (lang="en")=>{
   
    let resp=await api.get(`/blogs/categories/all?lang=${lang}`);    
    if(resp){
      resp=[{category: "Latest",subCategories:[]}, ...resp];
      setAllCategories(resp);
      let cookecat=setSelectedCategory(Cookies.get('selectedCategory'));
      if(cookecat && cookecat!='' && resp.findIndex(cat=>cat.category===cookecat)>=0){
      Cookies.get('selectedsubcategory') 
      let subcat=setSelectedSubCategory(Cookies.get('selectedsubcategory'));
      if(subcat && subcat.length>0 && resp.find(cat=>cat.category===cookecat).subCategories.includes(subcat)){
        setSelectedSubCategory(subcat);
      }
    }else{
      setSelectedCategory(resp[0].category)
    }
  }

  }
  const fetchArticles = async (page, language="en", category="Latest", subcat=undefined, append=false) => {
    try {
      // build query parameters to siply append on url based on subcategory is ther or not
      let queryParams = `?page=${page || 0}&lang=${language}`;
      if (category && category !== "Latest") {
        queryParams += `&category=${category}`;
      }
      if (subcat) {
        queryParams += `&subcat=${subcat}`;
      }
    const response = await api.get(`/blogs/all${queryParams}`);
    const { content, totalPages, number } = response;
    setPageNumber(number);
    setTotalPages(totalPages);
    if(content.length === 0){
      setIsEmptyResponse(true);
    }else{
      setIsEmptyResponse(false);
    }

      
      
      const processedArticles = content.map((article) => ({
        ...article,
        // coverImageUrl comes from the backend (URL path, e.g. /articles/img.jpg)
        coverImage: article.coverImageUrl || null,
        author: article.author==="sushensable"? "Sushen Sable": article.author,
        date: new Date(article.createdAt).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        }),
      }));

      if (append) {
        setArticles(prev => [...prev, ...processedArticles]);
        setFilteredArticles(prev => [...prev, ...processedArticles]);
      } else {
        setArticles(processedArticles);
        setFilteredArticles(processedArticles);
      }
    } catch (error) {
      console.error("Error fetching articles:", error);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    filterArticles(query);
  };

  const filterArticles = (query) => {
    let filtered = articles;
    if (query) {
      filtered = filtered.filter((article) =>
        article.title.toLowerCase().includes(query)
      );
    }
    setFilteredArticles(filtered);
  };

  const truncateContent = (description, length = 100) => {
    if (!description) return "";
    const tempDiv = document.createElement("div");
      tempDiv.innerHTML = description;
    const plainText = tempDiv.innerText;
    return plainText.length > length ? plainText.substring(0, length) + "..." : plainText;
  };




  return (
    <>
      <Header />
      <div className="language-switcher">
        <button
          className={language === "en" ? "active" : ""}
          
          onClick={async () =>  {
            if(language !== "en"){
            await setLanguage("en");
            fetchCategories("en");
            fetchArticles(0, "en");
            }
          }
          }
          >
          English
        </button> 
        <button
          className={language === "Marathi" ? "active" : ""}
          onClick={async () =>{
            if(language !== "Marathi"){
            await setLanguage("Marathi");
            fetchCategories("Marathi");
            await fetchArticles(0, "Marathi",);
            }
          }
        } 
        >
          Marathi
        </button>
      </div>

      
      
      {/* Search  */}
      <div className="search-categories">
        <input
          type="text"
          placeholder="Search articles..."
          value={searchQuery}
          className="search-input"
          onChange={handleSearch}
        />
      </div>
       <div className="categories">
        {allCategories.map((category) => (
          <button
            key={category.category}
            className={`category-button ${selectedCategory === category.category ? "active" : ""}`}  
            onClick={() => {
              if(selectedCategory !== category.category){
              setSelectedCategory(category.category);
              setSubCategories(category.subCategories)
              setArticles([]);
              fetchArticles(0,language, category.category);
              Cookies.set('selectedCategory', category.category);
              Cookies.remove('selectedsubcategory');
            }
          }
            }
          >
            {category.category}
          </button>
        ))}
      </div>

        <br></br>
        {subCategories && subCategories.length>0 && <><br/></>}
      <div className="categories">
        {subCategories.map((subcat) => (
          <button
            key={subcat}
            className={`category-button sub-cat-btn ${selectedSubCategory === subcat ? "active" : ""}`}  
            onClick={()=>{
              if(selectedSubCategory !== subcat){
              setSelectedSubCategory(subcat);
              setArticles([]);
              fetchArticles(0,language, selectedCategory,subcat);
              Cookies.set('selectedsubcategory', subcat);
            }else{
              setSelectedSubCategory("");
              setArticles([]);
              fetchArticles(0,language, selectedCategory);
              Cookies.remove('selectedsubcategory');
            }
          }
            }
        
          >
            {subcat}
          </button>
        ))}
      </div>
      
      {filteredArticles.length === 0 && isEmptyResponse && 
        <p className="no-articles-message">No articles found.</p> }
      {filteredArticles.length === 0 && !isEmptyResponse && (
        <section className="articles-grid">
          {[...Array(6)].map((_, i) => (
            <div key={i} className="article-card skeleton-card">
              <div className="skeleton skeleton-img" />
              <div className="article-info">
                <div className="skeleton skeleton-tag" />
                <div className="skeleton skeleton-title" />
                <div className="skeleton skeleton-text" />
                <div className="skeleton skeleton-text short" />
              </div>
            </div>
          ))}
        </section>
      )}
      <section className="articles-grid">
        {filteredArticles.map((article) => (
          <div className="article-card" key={article.id}>
            <Link to={`/blog/${article.slug}`} className="card-link">
              {article.coverImage && <img src={article.coverImage} alt={article.title} />}
              <div className="article-info">
                <span className="category-tag">{article.category}</span>
                <h3 className="article-card-title">{article.title}</h3>
                <p>{truncateContent(article.description, 100)}</p>
                <div className="article-meta">
                  <span> <FaPenAlt /> {article.author}</span>
                  <span> <FaRegCalendarAlt /> {article.date}</span>
                  <span> <FaReadme /> {article.readTime || 7} minutes  </span>
                </div>
                <div className="likeAndViews">
                  <span className="views-count"> {article.views}  <FaEye /> </span>
                  <span className="read-more-link">
                    Read More →
                  </span>
                  <span className="likes-count"> {article.likes}  <FaThumbsUp className="like-icon" /></span>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </section>

      {/* Load More */}
      {filteredArticles.length > 0 && pageNumber + 1 < totalPages && (
        <div className="pagination">
          <button
            onClick={async () => {
              const newPage = pageNumber + 1;
              await fetchArticles(newPage, language, selectedCategory, selectedSubCategory || undefined, true);
            }}
          >
            Load More
          </button>
        </div>
      )}

      <Footer />
    </>
  );
};

export default HomePage;
